export const SAUDI_TERMS_AND_CONDITIONS_MAPPER = {
  EG: false,
  SA: true,
  AE: true
};

export const VAT_AVAILABILTY = {
  EG: false,
  SA: true
};
